import styles from "./SelectionSteps.module.css"

export default function SelectionSteps(){

  return(
    <div className={styles.mainContainer}>
      <h2 className={styles.mainContainer__title}>
        Этапы работ при подборе<br />авто под ключ
      </h2>
      <div className={styles.grid}>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>1</p>
            <h3 className={styles.grid__cellTitle}>Консультация и подписание договора</h3>
          </div>
          <p className={styles.grid__cellText}>
            Мы начинаем с общения, чтобы понять ваши потребности. 
            Вы рассказываете, какой автомобиль вам нужен, а мы предлагаем лучшие решения. 
            После этого заключаем договор, где фиксируем все договоренности.
          </p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>2</p>
            <h3 className={styles.grid__cellTitle}>Поиск подходящих вариантов</h3>
          </div>
          <p className={styles.grid__cellText}>
            На этом этапе мы проводим анализ рынка, подбираем автомобили, которые соответствуют вашим требованиям и бюджету. 
            Только проверенные варианты — никаких сюрпризов!
          </p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>3</p>
            <h3 className={styles.grid__cellTitle}>Проверка и осмотр автомобилей</h3>
          </div>
          <p className={styles.grid__cellText}>
            Мы тщательно проверяем каждый автомобиль: диагностика, юридическая чистота и даже осмотр на месте. 
            Все, чтобы вы были уверены в своём выборе.
          </p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>4</p>
            <h3 className={styles.grid__cellTitle}>Передача автомобиля</h3>
          </div>
          <p className={styles.grid__cellText}>
            Финальный штрих! 
            Мы готовим автомобиль к передаче, оформляем документы и делаем всё, чтобы покупка была приятной и комфортной.
          </p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>5</p>
            <h3 className={styles.grid__cellTitle}>Помощь с регистрацией и страховкой</h3>
          </div>
          <p className={styles.grid__cellText}>
            Чтобы вам не пришлось тратить время, мы поможем с оформлением документов: постановка на учет, выбор страховки — всё под ключ!
          </p>
        </div>
        <div className={styles.grid__cell}>
          <div className={styles.grid__cellTitleContainer}>
            <p className={styles.grid__cellNum}>6</p>
            <h3 className={styles.grid__cellTitle}>Поддержка после покупки</h3>
          </div>
          <p className={styles.grid__cellText}>
            Мы остаёмся на связи даже после передачи автомобиля. 
            Рекомендации по обслуживанию, помощь в решении вопросов — вы всегда можете на нас рассчитывать!
          </p>
        </div>
      </div>
    </div>
  )
}